import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { EngineService } from '../../engine.service';
import { EventsEnum } from '../../models/events.enum';
import { auditTime } from 'rxjs/operators';

@Component({
  selector: 'app-engine-camera-position',
  templateUrl: './engine-camera-position.component.html',
  styleUrls: ['./engine-camera-position.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EngineCameraPositionComponent implements OnInit {
  camera: any = {
    x: 0,
    y: 0,
    z: 0,
    dist: 0,
  };

  constructor(
    private engineService: EngineService,
    private changeDetectionRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.initCameraListener();
  }

  initCameraListener() {
    this.engineService
      .getEvent(EventsEnum.CameraUpdated)
      .pipe(auditTime(50))
      .subscribe((camera) => {
        this.camera = {
          x: camera.eye.x.toFixed(0),
          y: camera.eye.y.toFixed(0),
          z: camera.eye.z.toFixed(0),
          dist: camera.dist.toFixed(0),
        };

        this.changeDetectionRef.markForCheck();
      });
  }
}
